import { safeScrollTo } from "@faire/retailer-visitor-shared/lib/safeScrollTo";
import {
  SHOP_SECTION_ID,
  TOP_OF_PRODUCT_SPACE,
} from "@faire/retailer-visitor-shared/views/brand/consts";
import { getDocumentOrThrow } from "@faire/web/common/globals/getDocument";
import { throttleIfPossible } from "@faire/web/common/globals/throttleIfPossible";
import { useRef } from "react";

const scrollToShopSectionThrottleMS = 500;

function scrollToShopSection() {
  const offsetTop =
    (getDocumentOrThrow().getElementById(SHOP_SECTION_ID)?.offsetTop ?? 0) -
    TOP_OF_PRODUCT_SPACE;

  safeScrollTo({
    left: 0,
    top: offsetTop,
    behavior: "smooth",
  });
}

export const useThrottledScrollToShopSection = (): (() => void) => {
  const throttledFn = useRef(
    throttleIfPossible(scrollToShopSection, scrollToShopSectionThrottleMS)
  );
  return throttledFn.current;
};
